import type { Chapter } from '@code-arcade/engine'

export const chapter6: Chapter = {
  id: 'chapter-6',
  number: 6,
  title: 'Due Diligence',
  company: 'ByteForge → exit',
  devTitle: 'VP Engineering',
  conflict: "Acquirer wants 40 metric queries answered in one hour. 3 years of sorted data.",
  intro: [
    { character: 'the-algorithm', mood: 'idle', dialogue: 'Two years in. ByteForge is acquired. Due diligence starts now.' },
    { character: 'vera-lox', mood: 'urgent', dialogue: 'The acquirer wants to know when latency first crossed 500ms. You have 3 years of deployment metrics.' },
    { character: 'dev-lama', mood: 'idle', dialogue: 'Millions of data points. All sorted by timestamp.' },
    { character: 'raj-lohani', mood: 'stressed', dialogue: 'They want 40 of these queries answered in the next hour. Our jobs depend on this going well.' },
    { character: 'dev-lama', mood: 'idle', dialogue: 'Sorted data. Find a boundary. That is one call each.' },
    { character: 'the-algorithm', mood: 'happy', dialogue: 'Binary search. The oldest trick in the book. O(log n). 22 comparisons in 3 million records.' },
  ],
  challengeIds: ['binary-search'],
}
